import React, { PureComponent } from 'react';
import { func } from 'prop-types';
import styled from 'styled-components';
import { fontFamily, fontSize } from '../../../../../../../constants/text';
import { colors } from '../../../../../../../constants/colors';
import DefaultButtons from './DefaultButtons';
import NextReminder from './NextReminder';
import ReminderFlavor from './ReminderFlavor';
import TitleControl from './TitleControl';
import NextReminderModal from '../../../CategoryContainers/HealthChecklistContainer/Modals/NextReminder';
import LastCheckup from '../../../CategoryContainers/HealthChecklistContainer/Modals/LastCheckup';
import { BIRTHSEX_TYPE_MALE } from '../../../../../../../constants/index';
import { isReminderComplete } from './util';
import AdditionalInfo from '../../../CategoryContainers/HealthChecklistContainer/Modals/AdditionalInfo';
import { analyticsTrackEvent } from '../../../../../../../core/analytics';
import {
  REMINDERS_ACTION,
  REMINDERS_CLICK_CHECKBOX,
  REMINDERS_MARK_REMINDER,
} from '../../../../../../Account/Profile/Reminders/util/tracking';
import { getDefaultReasonForVisitForProviderType } from '../../../../../../../core/util/symptoms';
import withTileAction from '../../../util/withTileAction';

const Root = styled.div.withConfig({ componentId: 'sc-1vhjnx9-0' })`
  padding: 14px 16px;
  box-sizing: border-box;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background: ${colors.theWhiteAlbum};
  border-radius: 8px;
`;

const Title = styled.span.withConfig({ componentId: 'sc-1vhjnx9-1' })`
  color: ${colors.squid};
  font-size: ${fontSize.default};
  font-family: ${fontFamily.bold};
`;

const Description = styled.div.withConfig({ componentId: 'sc-1vhjnx9-2' })`
  color: ${colors.lightText};
  font-size: ${fontSize.mediumSmall};
  font-family: ${fontFamily.book};
  margin-top: 6px;
`;

const FindButton = styled.div.withConfig({ componentId: 'sc-1vhjnx9-3' })`
  padding: 16px 16px 0;
  margin: 0 -16px;
  border-top: 1px solid ${colors.greyHounds};
`;

type Props = {
  userReminders?: object;
  // @ts-expect-error ts-migrate(2749) FIXME: 'func' refers to a value, but is being used as a t... Remove this comment to see the full error message
  openModal?: func;
  // @ts-expect-error ts-migrate(2749) FIXME: 'func' refers to a value, but is being used as a t... Remove this comment to see the full error message
  setBirthSex?: func;
  tileIndex?: number;
  userProfile?: object;
  locations?: object;
  tile?: object;
  // @ts-expect-error ts-migrate(2749) FIXME: 'func' refers to a value, but is being used as a t... Remove this comment to see the full error message
  setBookingFields?: func;
  // @ts-expect-error ts-migrate(2749) FIXME: 'func' refers to a value, but is being used as a t... Remove this comment to see the full error message
  doTileAction?: func;
};

class HealthChecklist extends PureComponent<Props> {
  get reminder() {
    const { userReminders, tile } = this.props;
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    return (userReminders.result || {})[tile.id];
  }

  handleCheck = (doneResponse: any) => {
    const { tile, openModal } = this.props;
    analyticsTrackEvent(REMINDERS_ACTION, {
      action: REMINDERS_CLICK_CHECKBOX,
      response: doneResponse,
      // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
      title: tile.title,
      // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
      reminderType: tile.id,
    });
    openModal(NextReminderModal.MODAL_ID, {
      // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
      reminder_type: tile.id,
      // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
      title: tile.title,
      ...this.reminder,
      doneResponse,
    });
  };

  handleResponse = (doneResponse: any) => {
    const { tile, openModal } = this.props;
    analyticsTrackEvent(REMINDERS_ACTION, {
      action: REMINDERS_MARK_REMINDER,
      response: doneResponse,
      // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
      title: tile.title,
      // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
      reminderType: tile.id,
    });
    openModal(doneResponse ? LastCheckup.MODAL_ID : NextReminderModal.MODAL_ID, {
      // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
      reminder_type: tile.id,
      // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
      title: tile.title,
      ...this.reminder,
      doneResponse,
    });
  };

  handleClick = (e: any) => {
    e && e.preventDefault();
    const { tileIndex, tile, userProfile, locations, setBookingFields, doTileAction } = this.props;

    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    if ('providerType' in tile) {
      const bookingFields = {
        symptoms: getDefaultReasonForVisitForProviderType(tile.providerType),
        providerType: tile.providerType,
      };
      setBookingFields(bookingFields);
    }

    // @ts-expect-error ts-migrate(2339) FIXME: Property 'recent' does not exist on type 'object'.
    doTileAction(tileIndex, tile, userProfile, locations && locations.recent);
  };

  handleSetMan = () => {
    const {
      setBirthSex,
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'user_profile_id' does not exist on type ... Remove this comment to see the full error message
      userProfile: { user_profile_id: id },
    } = this.props;
    setBirthSex(id, BIRTHSEX_TYPE_MALE);
  };

  handleReminderClick = () => {
    const { tile, openModal } = this.props;
    openModal(NextReminderModal.MODAL_ID, {
      // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
      reminder_type: tile.id,
      // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
      title: tile.title,
      ...this.reminder,
      doneResponse: isReminderComplete(this.reminder),
    });
  };

  openInfo = () => {
    const { tile, openModal } = this.props;
    openModal(AdditionalInfo.MODAL_ID, {
      ...tile,
      // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
      reminder_type: tile.id,
      ...this.reminder,
    });
  };

  render() {
    const {
      tile,
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'id' does not exist on type 'object | und... Remove this comment to see the full error message
      tile: { id, title, description },
    } = this.props;
    const { reminder } = this;

    return (
      <Root data-testid={`HealthChecklist-${id}`}>
        <div>
          <ReminderFlavor reminder={reminder} />

          <TitleControl handleClick={this.handleCheck} openInfo={this.openInfo} reminder={reminder}>
            <Title>{title}</Title>
          </TitleControl>

          <Description>{!reminder && description}</Description>
        </div>
        {reminder ? (
          <NextReminder onClick={this.handleReminderClick} reminder={reminder} />
        ) : (
          <DefaultButtons handler={this.handleResponse} setMale={this.handleSetMan} tile={tile} />
        )}
      </Root>
    );
  }
}

export default withTileAction(HealthChecklist);
